import './App.css';
import 'typeface-roboto';
import React, { Fragment } from 'react';
import Toolbar from './Toolbar';
import Content from './Content';
import Toast from './Shared/Toast';
import Login from './Login';
import { RootState } from '../reducers';
import { thunkFetchTorrents, thunkFetchSettings, thunkConnectSocket, thunkAuthSocket } from '../thunks';
import { connect } from 'react-redux';
import { ToastState } from '../types';
import { CssBaseline } from "@material-ui/core";
import { setToastMsg, setLogin } from '../actions';
import client from '../thunks/client';


interface AppProps {
  fetchTorrents: () => void;
  fetchSettings: () => void;
  toast: ToastState;
  setToastMsg: typeof setToastMsg;
  connectSocket: () => void;
  authSocket: () => void;
  setLogin: (needed: boolean) => void;
  login: boolean;
}

class App extends React.Component<AppProps> {

  componentDidMount() {
    client.onError = e => {
      if (e.response.status === 401) {
        this.props.setLogin(true);
      }
    }
    this.init();
  }

  init() {
    const {
      fetchTorrents,
      fetchSettings,
      connectSocket,
      authSocket,
    } = this.props;
    fetchTorrents();
    fetchSettings();
    connectSocket();
    authSocket();
  }


  render() {
    const { toast, setToastMsg, setLogin, login } = this.props;

    const handleLogged = () => {
      setLogin(false);
      this.init();
    }

    return (
      <div id="app">
        {!login &&
          <Fragment>
            <CssBaseline />
            <Toolbar />
            <Content />
          </Fragment>
        }
        {login &&
          <Login onOk={handleLogged} />
        }
        <Toast message={toast.message} variant={toast.variant} onClose={() => setToastMsg()} />
      </div>
    )
  }
}

const mapState = (state: RootState) => {
  return {
    toast: state.toast,
    login: state.login,
  }
}

const mapDispatch = {
  fetchTorrents: thunkFetchTorrents,
  fetchSettings: thunkFetchSettings,
  connectSocket: thunkConnectSocket,
  authSocket: thunkAuthSocket,
  setLogin,
  setToastMsg,
}

export default connect(mapState, mapDispatch)(App);